import React, { useState } from "react";

import { AuditFiter, TradeListError } from "@/components";
import {
  AuditTradeItem,
  AUDIT_COLS,
} from "@/components/TradeList/AuditTradeRow";
import { LedgerTable } from "./ledgerTable";

export const AuditTradeList = ({
  exchange,
  asset,
  isSearching,
  trades,
  isQueryLoading,
  hasLinkedExchangeAccount,
  error,
  filters,
  setFilters,
  summary,
}) => {
  const [isError, setIsError] = useState(false);

  let items = trades?.items;

  const tradeListErrorProps = {
    error,
    isSearching,
    setIsError,
    trades,
    items,
  };

  return (
    <div className="flex flex-col gap-[var(--gap)] ms1100:flex-row ms1100:items-start">
      <AuditFiter filters={filters} setFilters={setFilters} summary={summary} />
      <div className="min-w-0 flex-1">
        <TradeListError {...tradeListErrorProps} />
        <div className="ms900:overflow-x-auto">
          <LedgerTable cols={AUDIT_COLS}>
            {isQueryLoading ? (
              Array(10)
                .fill(0)
                .map((item, idx) => (
                  <AuditTradeItem key={idx} screen="md" isQueryLoading={isQueryLoading} />
                ))
            ) : items?.length > 0 ? (
              items?.map((txn) => (
                <AuditTradeItem
                  key={txn.id}
                  screen="md"
                  txn={txn}
                  isQueryLoading={isQueryLoading}
                />
              ))
            ) : (
              <AuditTradeItem
                screen="md"
                isEmpty={true}
                text="No results"
                isQueryLoading={isQueryLoading}
              />
            )}
          </LedgerTable>
        </div>
      </div>
    </div>
  );
};
